import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { EInstitutionType } from '@ucheba/store/institutions/item/types'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { IUseRotationBannerAndAdmissionInstructions } from './types'
import { isPaidPackage } from '../../ssr/[id]/utils/isPaidPackage'

const randomInt = Math.floor(Math.random() * 2)

export const useRotationBannerAndAdmissionInstructions =
  (): IUseRotationBannerAndAdmissionInstructions => {
    const { paidPackage, id, admissionInstruction, type } = useSelector(
      institutionItemSelectors.currentInstitution
    )

    const [showAdmissionInstruction, setShowAdmissionInstruction] =
      useState<boolean>(true)

    useEffect(() => {
      if (admissionInstruction && isPaidPackage(paidPackage)) {
        setShowAdmissionInstruction(true)
      } else if (admissionInstruction) {
        setShowAdmissionInstruction(randomInt !== 1)
      } else {
        setShowAdmissionInstruction(false)
      }
    }, [])

    const isShowBanner = [
      EInstitutionType.TrainingCenter,
      EInstitutionType.ForeignUniversity,
    ].includes(type?.value)

    const isSchool = EInstitutionType.School === type?.value

    return {
      isShowBanner,
      isSchool,
      showAdmissionInstruction,
      id,
      admissionInstruction,
      paidPackage,
    }
  }
